module.exports = __webpack_public_path__ + "img/plan-3-2.083a6e06.png";